"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPasswordValidationSchema = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var app_1 = __importDefault(require("firebase/app"));
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var useTitle_1 = __importDefault(require("react-use/lib/useTitle"));
var use_react_router_1 = __importDefault(require("use-react-router"));
var Yup = __importStar(require("yup"));
var styles = __importStar(require("./Login.modules.css"));
exports.resetPasswordValidationSchema = Yup.object().shape({
    email: Yup.string()
        .email()
        .min(2)
        .max(50)
        .required(),
});
function ResetPassword() {
    var _this = this;
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)("Reset Password");
    var history = (0, use_react_router_1.default)().history;
    var formProps = (0, formik_1.useFormik)({
        initialValues: {
            email: "",
        },
        validationSchema: exports.resetPasswordValidationSchema,
        onSubmit: function (values) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, app_1.default.auth().sendPasswordResetEmail(values.email)];
                    case 1:
                        _a.sent();
                        antd_1.message.success(t("alerts.success"));
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.warn(error_1);
                        antd_1.message.error(t("alerts.wrongEmail"));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    });
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: styles.Container }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.formContainer }, { children: [(0, jsx_runtime_1.jsx)("h2", { children: t("auth.resetPassword") }), (0, jsx_runtime_1.jsxs)(antd_1.Form, __assign({ onFinish: formProps.submitForm }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("email").touched) &&
                                formProps.errors.email &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("email").touched) &&
                                formProps.errors.email, label: t("auth.email") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { prefix: (0, jsx_runtime_1.jsx)(icons_1.GlobalOutlined, { className: styles.emailInputIcon }), type: "email", onChange: formProps.handleChange("email"), value: formProps.values.email }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.changePasswordButtonContainer }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: function () {
                                            navigate("/login");
                                        }, type: "default", className: styles.loginFormButton }, { children: t("auth.back") })), (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "primary", htmlType: "submit", loading: formProps.isSubmitting, className: styles.loginFormButton }, { children: t("auth.verify") }))] })) })] }))] })) })));
}
exports.default = ResetPassword;
